
import Vue, { PropType } from 'vue';

// Types
import { Membership } from '~/services/CandidateService';
import { format } from '~/utils/date-fns';

// Components
import Icon from '~/components/builders/Base/Icon.vue';
import IconBtn from '~/components/builders/IconBtn.vue';

export default Vue.extend({
    name: 'MembershipListItem',
    components: { Icon, IconBtn },
    props: {
        ms: {
            type: Object as PropType<Membership>,
            required: true,
        },
        editMode: Boolean,
        disableSidebar: Boolean,
    },
    computed: {
        startText(): string {
            if (this.ms.start) {
                return format(this.ms.start, 'MMM yyyy');
            }
            return '';
        },
        endText(): string {
            if (this.ms.end) {
                return format(this.ms.end, 'MMM yyyy');
            }
            return this.ms.isActive ? this.$t('profile.memberships.form.present').toString() : '';
        },
    },
});
